import React from "react";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    CircularProgress,
    FormControl,
    Grid,
    TextField,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { isDateExpired } from "../Utils/UtilityMethods";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

interface Props {
    expanded: boolean;
    accordianIndexValue: number;
    accordionClicked(arg0: number): void;
    error: any;
    data: any;
    loading: boolean;
}

export default function IfrCurrencySection(props: Props): JSX.Element {
    const theme = useTheme();
    const isMedium = useMediaQuery(theme.breakpoints.up("sm"));

    let horizontalPadding = 4;

    if (isMedium) horizontalPadding = 6;
    return (
        <>
            <FormControl fullWidth sx={{ px: horizontalPadding }}>
                <Accordion sx={{ background: "#F7F8F9" }} expanded={props.expanded} onChange={() => props.accordionClicked(props.accordianIndexValue)}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Grid container justifyContent={"space-between"} alignItems={"center"}>
                            <Typography variant="button" fontSize={18} marginLeft={2}>
                                IFR CURRENCY
                            </Typography>
                            {props.loading ? <CircularProgress size={25} sx={{ mr: 2 }} /> : null}
                        </Grid>
                    </AccordionSummary>
                    {!props.loading && props.data && props.data.getIfrCurrencyByPersonAndDate ? (
                        <AccordionDetails>
                            <Box marginLeft={2} marginBottom={1} marginTop={2}>
                                <Grid container alignItems="baseline">
                                    <TextField
                                        size="small"
                                        sx={{ width: 110 }}
                                        inputProps={{
                                            style: {
                                                textAlign: "end",
                                                borderRadius: 4,
                                                background: "white",
                                            },
                                        }}
                                        value={
                                            (props.data.getIfrCurrencyByPersonAndDate.totals &&
                                                props.data.getIfrCurrencyByPersonAndDate.totals[0]?.ifr_hours) ??
                                            ""
                                        }
                                    />
                                    <Typography fontSize={16} sx={{ marginLeft: 1, display: "inline" }}>
                                        IFR Hours Last 180
                                    </Typography>
                                </Grid>
                            </Box>
                            <Box marginLeft={2} marginBottom={1} marginTop={2}>
                                <Grid container alignItems="baseline">
                                    <TextField
                                        size="small"
                                        sx={{ width: 110 }}
                                        inputProps={{
                                            style: {
                                                textAlign: "end",
                                                borderRadius: 4,
                                                background: "white",
                                            },
                                        }}
                                        value={
                                            (props.data.getIfrCurrencyByPersonAndDate.totals &&
                                                props.data.getIfrCurrencyByPersonAndDate.totals[0]?.ifr_approaches) ??
                                            ""
                                        }
                                    />
                                    <Typography fontSize={16} sx={{ marginLeft: 1, display: "inline" }}>
                                        IFR Approaches Last 180
                                    </Typography>
                                </Grid>
                            </Box>
                            <Box marginLeft={2} marginBottom={1} marginTop={2}>
                                <Grid container alignItems="baseline">
                                    <TextField
                                        size="small"
                                        sx={{ width: 110 }}
                                        inputProps={{
                                            style: {
                                                textAlign: "end",
                                                borderRadius: 4,
                                                background: "white",
                                            },
                                        }}
                                        value={
                                            (props.data.getIfrCurrencyByPersonAndDate.expirations &&
                                                props.data.getIfrCurrencyByPersonAndDate.expirations[0]?.expiry) ??
                                            ""
                                        }
                                    />
                                    {props.data.getIfrCurrencyByPersonAndDate.expirations &&
                                    isDateExpired(props.data.getIfrCurrencyByPersonAndDate.expirations[0]?.expiry) ? (
                                        <Typography fontSize={16} sx={{ marginLeft: 1, display: "inline" }} color={"error"}>
                                            Expired
                                        </Typography>
                                    ) : (
                                        <Typography fontSize={16} sx={{ marginLeft: 1, display: "inline" }}>
                                            Expiry
                                        </Typography>
                                    )}
                                </Grid>
                            </Box>
                        </AccordionDetails>
                    ) : null}
                </Accordion>
            </FormControl>
        </>
    );
}
